import { Action } from '@reduxjs/toolkit';
import React, { createContext, PropsWithChildren, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { CurrentSporsmalAction } from './currentSporsmalReducer';

export const DispatchContext = createContext(null);

export const useSporsmalsflytDispatch = () => useContext(DispatchContext);

interface Props {
    mapAction?: (action: CurrentSporsmalAction) => CurrentSporsmalAction;
}

export const SporsmalsflytDispatchProvider: React.FC<PropsWithChildren<Props>> = ({ mapAction, children }) => {
    const dispatch: Dispatch<Action> = useDispatch();
    const sporsmalflytDispatch = useSporsmalsflytDispatch();

    const sporsmalsflytDispatch = useCallback(
        (action: CurrentSporsmalAction | ((d: (a: CurrentSporsmalAction) => void) => void)) => {
            if (mapAction) {
                if (typeof action === 'function') {
                    action((a) => {
                        sporsmalflytDispatch(mapAction(a));
                    });
                } else {
                    sporsmalflytDispatch(mapAction(action));
                }
            } else {
                dispatch(action as CurrentSporsmalAction);
            }
        },
        [dispatch, mapAction, sporsmalflytDispatch],
    );

    return <DispatchContext.Provider value={sporsmalsflytDispatch}>{children}</DispatchContext.Provider>;
};
